import React from 'react';
import Button from '@material-ui/core/Button';
import { joinDefined, stringIsNullOrEmpty } from '../../utils/strings';
import CloseIcon from '../icon/CloseIcon';
import history from '../../utils/history';
import { IconButton } from '@material-ui/core';

/**
 * Primary coloured button
 * variants:
 	primary
	secondary
	tertiary
 	quaternary
 	urgent
	confirmation
	modal-action
	tag
 */
const ButtonWrapper = ({
    classes,
    onClick,
    children,
    className,
    color,
    href,
    size,
    icon,
    target,
    variant = 'primary',
    ...props
}) => {
    const variants = variant.split(' ');
    const sizeCss = !stringIsNullOrEmpty(size) ? `button-base--${size}` : null;

    const onClickEvent = e => {
        if (e && href) {
            e.preventDefault();
        }
        if (onClick) return onClick(e);
        else if (target) return window.open(href, target);
        return history.push(href);
    };

    if (variant.includes('link')) {
        return (
            <a
                href={href}
                target={target || undefined}
                onClick={onClickEvent}
                //classes={{ root: 'button-label' }}
                className={`button-base ${variant} ${sizeCss || ''} ${!!target && 'newwindow'}`}
            >
                {props.text || children}
            </a>
        );
    }

    if (variants.indexOf('tag') > -1) {
        const { disabled } = props;
        return (
            <div className={`button-base ${variant} ${sizeCss || ''}`} disabled={disabled}>
                <span className="button-label">{children}</span>
                {onClick && (
                    <span
                        style={disabled ? { opacity: 0.25 } : null}
                        onClick={!disabled && onClickEvent}
                        onKeyDown={!disabled && onClickEvent}
                        role="button"
                        tabIndex="0"
                        className={`icon-button ${variant}`}
                        title="Remove"
                    >
                        <CloseIcon />
                    </span>
                )}
            </div>
        );
    }
    if (icon && !children) {
        return (
            <IconButton
                variant="contained"
                color="primary"
                onClick={onClickEvent}
                className={`button-base icon-button ${joinDefined([variant, sizeCss], ' ')}`}
                classes={{ label: `button-label ${!!target && 'newwindow'}` }}
                {...props}
            >
                {icon}
            </IconButton>
        );
    }

    return (
        <Button
            variant="contained"
            color="primary"
            onClick={onClickEvent}
            className={`button-base ${joinDefined([variant, sizeCss], ' ')}`}
            classes={{ label: `button-label ${!!target && 'newwindow'}` }}
            {...props}
        >
            {icon}
            {children}
        </Button>
    );
};

export default ButtonWrapper;
